import './polyfills';

import('./standalone-bootstrap');
